export default __webpack_public_path__ + "static/media/excel.95747d4f.svg";